import React, { memo } from "react";

import { ButtonBase, Paper, styled, Typography } from '@mui/material';
import { NftData } from "../../types/nft";
import NftImage from "./NftImage";

import { areEqual } from 'react-window';
import { Link } from "@reach/router";




const Root = styled(Paper)({
  position: 'relative',
  overflow: 'hidden',
});


const Bottom = styled('div')({
  backgroundColor: 'rgba(0, 0, 0, 0.4)',
  color: '#fff',
  position: 'absolute',
  left: 0,
  bottom: 0,
  padding: 5,
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
})

interface Props {
  data: NftData;
  url?: string;
  size: number;
}

const NftCard: React.FC<Props> = ({ data, url, size }) => {

  const card = (
    <Root style={{width: size, height: size}}>
      <NftImage attributes={data.attributes} width={size} height={size} />
      <Bottom>
        <Typography>
          HayApe #{data.tokenId}
        </Typography>
        <Typography>
          {data.rarity}
        </Typography>
      </Bottom>
      {
        url ? <ButtonBase component={Link} to={url} style={{ width: '100%', height: '100%', position: 'absolute' }}></ButtonBase> : null
      }
    </Root>
  );


  return card;
};

export default memo(NftCard, areEqual);